import React, { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { useUpdateOrganisationMembership } from "../../../../store";

interface DemoteUserConfirmationModalProps {
  organisationId: string;
  userId: string;
  open: boolean;
  onClose: () => void;
}

const DemoteUserConfirmationModal: React.FC<
  DemoteUserConfirmationModalProps
> = ({ organisationId, userId, open, onClose }) => {
  const [inProgress, setInProgress] = useState<boolean>(false);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({
    open: false,
    message: "",
    severity: "success",
  });

  const onSuccess = () => {
    setSnackbar({
      open: true,
      message: "User demoted successfully",
      severity: "success",
    });
    setInProgress(false);
    onClose();
  };

  const onError = (err: unknown) => {
    console.log(err);
    setSnackbar({
      open: true,
      message: "Failed to demote user",
      severity: "error",
    });
    setInProgress(false);
    onClose();
  };

  const { mutate: updateOrganisationMembership } =
    useUpdateOrganisationMembership(onSuccess, onError);

  const onConfirm = () => {
    setInProgress(true);
    updateOrganisationMembership({
      organisationId: organisationId,
      input: {
        targetId: userId,
        membership: "true",
      },
    });
  };

  const onSnackbarClose = () => {
    setSnackbar((current) => ({
      ...current,
      open: false,
    }));
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle component="div">
          <Typography variant="h3">Demote Team Member</Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Typography variant="body1">
              Are you sure you want to demote this admin to member?
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="outlined"
            fullWidth
            disabled={inProgress}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            color="error"
            variant="contained"
            disabled={inProgress}
            fullWidth
          >
            {inProgress ? "Demoting User..." : "Demote"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={onSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={onSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DemoteUserConfirmationModal;
